/**
 * Which full-screen gate (if any) stands between a signed-in user and the app.
 * Pulled out of App.tsx so the ORDER is testable without Firebase.
 *
 * Order: legal terms first for everyone (staff included — they will see
 * advocates' usage data), then:
 *   - a support user goes straight to the Support Desk shell. They have no
 *     practice areas, trial or entitlement, so the signup wizard, workspace
 *     chooser and trial gate must never run for them;
 *   - everyone else: the signup wizard if not onboarded, else the app.
 */
export type Gate = 'legal' | 'support' | 'wizard' | 'app';

interface GateProfile {
  is_onboarded: boolean;
  staff_role?: 'none' | 'support';
}

export function nextGate(
  profile: GateProfile,
  state: { legalAccepted: boolean; onboardingComplete: boolean },
): Gate {
  if (!state.legalAccepted) return 'legal';
  if (profile.staff_role === 'support') return 'support';
  if (!state.onboardingComplete && profile.is_onboarded === false) return 'wizard';
  return 'app';
}
